<template>
	<div>
		<div class="mian">
			<div class="titles fcs">
				<div class="fc">
					<div class="hr"></div>
					<div>招标公告</div>
					<div class="p">BIDDING NOTICE</div>
				</div>
				<div class="tabbox fc">
					<div :class="category_id == '1'?'tab-a fcc':'tab fcc'" @click="changecategory_id('1')">工程专区</div>
					<div :class="category_id == '2'?'tab-a fcc':'tab fcc'" @click="changecategory_id('2')">物资采购</div>
				</div>
			</div>
			<div class="fcs" style="width: 1200px;">
				<div>
					<el-carousel class="swiper" indicator-position="none">
						<el-carousel-item class="swiperitem" v-for="(item,index) in bannerlist" :key="index">
							<div>
								<img :src="item" alt="">
								<div class="title">123</div>
								<div class="p">456</div>
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div>
					<div class="itembox">
						<div class="item fcs" v-for="(item,index) in list1" :key="index" @click="godetails(item.id)">
							<div class="title">{{item.title}}</div>
							<div class="time">{{item.createtime}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="fcs">
				<div class="titles fcs" style="width: 580px;">
					<div class="fc">
						<div class="hr"></div>
						<div>公示公告</div>
						<div class="p">PUBLIC ANNOUNCEMENT</div>
					</div>
					<!-- <div class="gengduo">+更多</div> -->
				</div>
				<div class="titles fcs" style="width: 580px;">
					<div class="fc">
						<div class="hr"></div>
						<div>办事指南</div>
						<div class="p">SERVICE GUIDE</div>
					</div>
					<!-- <div class="gengduo">+更多</div> -->
				</div>
			</div>
			<div class="fcs" style="width: 1200px;">
				<div class="itembox">
					<div class="item fcs" v-for="(item,index) in list2" :key="index" @click="godetails(item.id)">
						<div class="title">{{item.title}}</div>
						<div class="time">{{item.createtime}}</div>
					</div>
				</div>
				<div class="itembox">
					<div class="item fcs" @click="goNews3('7')">
						<div class="title">供应商入库指南</div>
						<div class="time">2023-08-08 22:00</div>
					</div>
					<div class="item fcs" @click="goNews3('8')">
						<div class="title">投标指南</div>
						<div class="time">2023-08-08 22:00</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				bannerlist: [], //轮播图
				category_id: '1', //1=工程专区,2=物资采购
				list1: [], //招标公告
				list2: [] //公示公告
			}
		},
		created() {
			this.getbannerlist();
			this.getlist1();
			this.getlist2();
		},
		methods: {
			//获取轮播图
			getbannerlist() {
				this.$api.home.banner().then(res => {
					if (res.code == 1) {
						this.bannerlist = res.data;
					}
				})
			},
			//切换分类
			changecategory_id(category_id) {
				this.category_id = category_id;
				this.getlist1();
			},
			//获取招标公告
			getlist1() {
				let data = {
					page: 1,
					limit: 8,
					category_id: this.category_id
				}
				this.$api.home.notice(data).then(res => {
					this.list1 = res.data.list;
				})
			},
			//获取公示公告
			getlist2() {
				let data = {
					page: 1,
					limit: 8,
					category_id: '3,4,5,6'
				}
				this.$api.home.notice(data).then(res => {
					this.list2 = res.data.list;
				})
			},
			//跳转详情
			godetails(id) {
				this.$api.home.noticeinfo({
					notice_id: id
				}).then(res => {
					if (res.code == 1) {
						this.$router.push({
							path: '/details',
							query: {
								id: id
							}
						})
					}
				})
			},
			goNews3(id) {
				this.$router.push({
					path: '/news3',
					query: {
						id: id
					}
				})
			}
		}
	}
</script>

<style scoped>
	.mian {
		width: 1200px;
		margin: 50px auto;
	}

	.mian .titles {
		font-size: 28px;
		margin: 40px 0;
		color: #0B457A;
	}

	.mian .titles .hr {
		width: 3px;
		height: 29px;
		background: #0B457A;
		margin-right: 17px;
	}

	.mian .titles .p {
		font-size: 20px;
		color: #919191;
		margin-top: 6px;
		margin-left: 11px;
	}

	.mian .titles .tabbox {
		cursor: pointer;
	}

	.mian .titles .tabbox .tab {
		width: 156px;
		height: 38px;
		background: #ECECEC;
		border-radius: 6px;
		font-size: 16px;
		margin-left: 20px;
	}

	.mian .titles .tabbox .tab-a {
		width: 156px;
		height: 38px;
		background: #0B457A;
		border-radius: 6px;
		font-size: 16px;
		color: #ffffff;
		margin-left: 20px;
	}

	.mian .titles .gengduo {
		font-size: 16px;
		cursor: pointer;
	}

	.mian .swiper {
		width: 580px;
		height: 428px;
	}

	.mian .swiper .swiperitem {
		width: 782px;
		height: 428px;
	}

	.mian .swiper .swiperitem img {
		width: 782px;
		height: 428px;
		object-fit: cover;
	}

	.itembox {
		width: 580px;
		height: 428px;
	}

	.itembox .item {
		width: 580px;
		height: 54px;
		border-bottom: #ADADAD dashed 1px;
		cursor: pointer;
	}

	.itembox .item:hover {
		color: #0B457A;
		font-weight: bold;
	}

	.itembox .item:hover .time {
		color: #0B457A;
	}

	.itembox .item .title {
		width: 400px;
		font-size: 16px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.itembox .item .time {
		font-size: 16px;
		color: #333333;
	}
</style>